import React, {memo} from "react"
import {shapeComponent, ShapeComponent} from "set-state-compare/build/shape-component"
import {ContactRelationship} from "models"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import Text from "@kaspernj/api-maker/build/utils/text"
import {View} from "react-native"

/**
 * @typedef {object} RoutesUserMyUsersRoleBadgeProps
 * @property {unknown} schoolRole
 */

/** @typedef {object} RoutesUserMyUsersRoleBadgeState */

/**
 * @extends {ShapeComponent<RoutesUserMyUsersRoleBadgeProps, RoutesUserMyUsersRoleBadgeState>}
 */
class RoutesUserMyUsersRoleBadge extends ShapeComponent {
  static propTypes = propTypesExact({
    schoolRole: PropTypes.instanceOf(ContactRelationship).isRequired
  })

  render() {
    const {schoolRole} = this.p
    const identifier = schoolRole.contactRelationshipType().identifier()
    let backgroundColor = "grey"

    if (identifier == "admin") {
      backgroundColor = "#a5Ebc1"
    } else if (identifier == "school_leader") {
      backgroundColor = "#fab0a6"
    } else if (identifier == "teacher") {
      backgroundColor = "#ffeea9"
    }

    return (
      <View
        style={this.cache("viewStyle", {
          paddingHorizontal: 7,
          paddingVertical: 1,
          backgroundColor,
          borderRadius: 22
        }, [backgroundColor])}
      >
        <Text style={this.textStyle ||= {fontWeight: "bold"}}>
          {schoolRole.contactRelationshipType().name()}
        </Text>
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesUserMyUsersRoleBadge))
